import { render, staticRenderFns } from "./ticketTip.vue?vue&type=template&id=4e0ca8fe&scoped=true"
import script from "./ticketTip.vue?vue&type=script&lang=js"
export * from "./ticketTip.vue?vue&type=script&lang=js"
import style0 from "./ticketTip.vue?vue&type=style&index=0&id=4e0ca8fe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ca8fe",
  null
  
)

export default component.exports